export const FIND_EMPLOYEE_ROLE_FAILURE = 'FIND_EMPLOYEE_ROLE_FAILURE';

export const findEmployeeRoleFailure = error => ({
    type: FIND_EMPLOYEE_ROLE_FAILURE,
    payload: error,
    error: true,
});
